// extracted by mini-css-extract-plugin
module.exports = {"buttons":"UploadResult_buttons_1l4Il","preview":"UploadResult_preview_1R9eR"};